<template>
  <el-dialog
    class="excellent-capabilities-add-server-config-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="serverDateForm"
      :model="serverDateForm"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-dynamic"
    >
      <el-form-item class="server-long" prop="email" label="服务器IP地址">
        <el-input v-model="serverDateForm.ip" :disabled="title == '修改服务器配置'"></el-input>
      </el-form-item>

      <el-form-item class="server-long" prop="email" label="服务器名称">
        <el-input v-model="serverDateForm.servername"></el-input>
      </el-form-item>

      <el-form-item
        v-for="(domain, index) in serverDateForm.domains"
        :key="domain.key"
        :label="'已部署服务端口'"
        :prop="'domains.' + index + '.value'"
      >
        <el-select v-model="domain.serverID" placeholder="请选择" @change="serveridChange(index)">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input v-model="domain.serverport"></el-input>

        <el-button @click.prevent="removeDomain(index)">删除</el-button>
      </el-form-item>

      <el-form-item style="text-align: right;">
        <el-button class="add-server" @click="addDomain">添加服务端口</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="addServer()">确定</el-button>&emsp;
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddServerConfig',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '',
      loadingBtn: false,
      dialogVisible: false,
      userid: '',
      isPing: false,
      serverDateForm: {
        ip: '', //服务ip
        servername: '', //服务器名称
        domains: [
          {
            serverID: null,
            serverport: null,
            isPing: false
          }
        ]
      },
      options: [
        {
          value: 1,
          label: '多方安全计算'
        },
        {
          value: 2,
          label: '密文检索'
        },
        {
          value: 3,
          label: '属性加密'
        },
        // {
        //   value: 4,
        //   label: '数据迁移'
        // }
      ],
      value: [],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    addDomain() {
      this.serverDateForm.domains.push({
        serverID: null,
        serverport: null,
        isPing: false
      })
    },
    removeDomain(index) {
      this.serverDateForm.domains.splice(index, 1)
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      if (data.title == '修改服务器配置') {
        var dataObj = data
        dataObj.domains = data.domains
        this.$set(this.serverDateForm, 'id', data.ip)
        this.$set(this.serverDateForm, 'servername', data.servername)
        this.$set(this.serverDateForm, 'ip', data.ip)
        this.$set(this.serverDateForm, 'domains', data.domains)
      } else {
        this.$set(this.serverDateForm, 'id', '')
        this.$set(this.serverDateForm, 'servername', '')
        this.$set(this.serverDateForm, 'ip', '')
        this.$set(this.serverDateForm, 'domains', [
          {
            serverID: null,
            serverport: null,
            isPing: false
          }
        ])
      }

      this.dialogVisible = true
      this.title = data.title
    },
    async addServer() {
      const userInfoStr = localStorage.getItem('cbaas_system_userInfo')
      const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
      var formObj = {}
      formObj.userid = String(userInfo.ID)
      formObj.ip = this.serverDateForm.ip
      formObj.servername = this.serverDateForm.servername

      this.serverDateForm.domains.map((item, index) => {
        item.serverport = Number(item.serverport)
      })

      formObj.encryptsvrs = this.serverDateForm.domains
      let params = JSON.stringify(formObj)

      if (this.title == '添加服务器配置') {
        this.$apis.excellent.encryptConfigAdd(params).then(res => {
          if (res.code != 0) {
            this.$message.success('添加成功！')
            this.$emit('getList')
            this.dialogVisible = false
          } else {
            this.$message.error('添加失败！' + res.error[0].message)
          }
          return
        })
      } else {
        this.$apis.excellent.encryptConfigModify(params).then(res => {
          if (res.code != 0) {
            this.$message.success('修改成功！')
            this.$emit('getList')
            this.dialogVisible = false
          } else {
            this.$message.error('修改失败！' + res.error[0].message)
          }
          return
        })
      }
    },
    serveridChange(index) {
      if (this.serverDateForm.domains[index].serverID == 1) {
        this.$set(this.serverDateForm.domains, index, { serverID: 1, serverport: 9030 })
      } else if (this.serverDateForm.domains[index].serverID == 2) {
        this.$set(this.serverDateForm.domains, index, { serverID: 2, serverport: 9031 })
      } else if (this.serverDateForm.domains[index].serverID == 3) {
        this.$set(this.serverDateForm.domains, index, { serverID: 3, serverport: 9032 })
      } else if (this.serverDateForm.domains[index].serverID == 4) {
        this.$set(this.serverDateForm.domains, index, { serverID: 4, serverport: 12091 })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.excellent-capabilities-add-server-config-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;

      :not(:first-child) {
        margin-left: var(--base-size-8);
      }
    }
  }
}
</style>
